const string = 'string'
export const GetServerTime = {}
export const DriverConductorListAll = {
  //method post
  intUserID: 0,
  intDriverConductorID: 0,
  intCompanyID: 0,
  intBusID: 0,
  intIsDriver: 0,
  intStateID: 0,
  intCityID: 0,
  intIsActive: 0,
}
export const GetVehicleNo = {
  //method post
  intCompanyID: 0,
  intFromCityID: 0,
  intToCityID: 0,
  dtJdate: `2023-02-02T02:10:50.069Z`,
  intMode: 0,
}
export const CargoGetRateForConsignment = {
  intCompanyID: 0,
  intFromCityID: 0,
  intToCityID: 0,
  intConsignmentID: 0,
  intIsExpress: 0,
  dcmActWeight: 0,
  intPaymentTypeID: 0,
  intPartyID: 0,
  intIsPartySender: 0,
}
export const CargoGetRateForConsignmentV2 = {
  // intCompanyID: 0,
  // intFromCityID: 0,
  // intToCityID: 0,
  // intConsignmentID: 0,
  // intIsExpress: 0,
  // dcmActWeight: 0,
  // intPaymentTypeID: 0,
  // intPartyID: 0,
  // intIsPartySender: 0,
  CompanyID: 0,
  ConsignmentID: 0,
  SourceCityID: 0,
  DestinationCityID: 0,
  Units: 0,
  Weight: 0,
  ServiceType: 2
}
export const GetAdditionalCharges = {
  intCompanyID: 0,
  intBranchID: 0,
  strConsignmentSubType: string,
  strEventType: string,
  PaymentType: 0,
  strGoodsvalue: string,
  strQuantities: string,
  intTotalQty: 0,
}
export const CargoPickupAndDropoffChargesListAll = {
  intCompanyID: 0,
  intBranchID: 0,
  ChargeTypeID: 0,
  unit: 0,
  mode: 0,
}
